<div class="map-wrapper" [class.selector-mode]="selectorMode">

  <!--  <div class="container">-->
  <!--    <div class="main-page-title inverted">ALAPRAJZOK-->
  <!--      <div class="three-dot">-->
  <!--        <div class="dot first"></div>-->
  <!--        <div class="dot second"></div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->

  <div class="container">
    <app-section-heading  [small]="smallHeader" [label]="'Alaprajzok'"></app-section-heading>
  </div>

  <div class="container">

    <div class="tabs-container">
      <nav mat-tab-nav-bar>
        <a mat-tab-link *ngFor="let level of buildingLevels"
           (click)="activeLevel = level.level"
           [active]="activeLevel === level.level">
          {{level.label}}
        </a>
      </nav>
    </div>
  </div>
  <div class="container">
    <div class="col-12 map-container animated fadeIn">

      <img class="direction-logo"
           [src]="'/assets/images/map/direction.png'">

      <app-image-map
        *ngIf="!flatsLoading"
        [selectedFlat]="highlightedFlat || selectedFlat"
        (pointSelected)="onPointSelected($event)"
        [selectorMode]="selectorMode"
        [flats]="flatsByLevel[activeLevel]"
        [mapImageUrl]="'/assets/images/levels/plan_' + activeLevel + '.jpg'"></app-image-map>
    </div>
  </div>
</div>
